import { Dropdown } from 'bootstrap';
import { passwordDialog } from './controls/index';

/**
 * Los menús de acciones viven dentro de tablas responsive. Bootstrap usa
 * `position: absolute` por defecto y el contenedor con scroll termina
 * recortándolos. La estrategia fixed los posiciona contra el viewport y
 * mantiene el menú visible sin desactivar el scroll horizontal de la tabla.
 */
export function initUserActionsMenus(root: ParentNode = document): void {
  root
    .querySelectorAll<HTMLElement>('[data-user-actions-menu] [data-bs-toggle="dropdown"]')
    .forEach((trigger) => {
      Dropdown.getOrCreateInstance(trigger, {
        boundary: 'viewport',
        popperConfig: (defaultConfig) => ({
          ...defaultConfig,
          strategy: 'fixed',
          modifiers: defaultConfig.modifiers.map((modifier: any) =>
            modifier.name === 'preventOverflow'
              ? {
                  ...modifier,
                  options: {
                    ...modifier.options,
                    rootBoundary: 'viewport',
                    altAxis: true,
                    tether: false,
                    padding: 12,
                  },
                }
              : modifier),
        }),
      });
    });

  const detailsModal = document.querySelector<HTMLDialogElement>(
    '[data-two-factor-details-modal]');
  if (!detailsModal) return;

  if (detailsModal.dataset.twoFactorModalReady !== '1') {
    detailsModal.dataset.twoFactorModalReady = '1';
    detailsModal.querySelectorAll<HTMLButtonElement>(
      '[data-two-factor-dialog-close]').forEach((closeButton) => {
        closeButton.addEventListener('click', () => detailsModal.close());
      });
    detailsModal.addEventListener('click', (event) => {
      if (event.target === detailsModal) detailsModal.close();
    });
  }

  root
    .querySelectorAll<HTMLButtonElement>('[data-two-factor-details]:not([data-two-factor-details-ready])')
    .forEach((trigger) => {
      trigger.dataset.twoFactorDetailsReady = '1';
      trigger.addEventListener('click', () => {
        const user = trigger.dataset.twoFactorUser || 'Usuario';
        const account = trigger.dataset.twoFactorAccount || 'No disponible';
        const label = trigger.dataset.twoFactorLabel || `Profint by Dataclinic:${account}`;
        detailsModal.querySelector<HTMLElement>('[data-two-factor-dialog-user]')!.textContent = user;
        detailsModal.querySelector<HTMLElement>('[data-two-factor-dialog-account]')!.textContent = account;
        detailsModal.querySelector<HTMLElement>('[data-two-factor-dialog-label]')!.textContent = label;
        detailsModal.showModal();
      });
    });

  root
    .querySelectorAll<HTMLFormElement>('[data-two-factor-self-reset]:not([data-two-factor-self-reset-ready])')
    .forEach((form) => {
      form.dataset.twoFactorSelfResetReady = '1';
      form.addEventListener('submit', async (event) => {
        if (form.dataset.twoFactorResetConfirmed === '1') {
          form.dataset.twoFactorResetConfirmed = '';
          return;
        }

        event.preventDefault();
        const password = await passwordDialog({
          title: 'Reconfigurar mi 2FA',
          text: 'Para confirmar que sos vos, ingresá tu contraseña actual.',
          placeholder: 'Contraseña actual',
          confirmText: 'Reconfigurar 2FA',
        });
        if (password === null) return;

        const input = form.querySelector<HTMLInputElement>(
          '[data-two-factor-current-password]');
        if (!input) return;
        input.value = password;
        form.dataset.twoFactorResetConfirmed = '1';
        form.requestSubmit();
      });
    });
}

function initialize(): void {
  initUserActionsMenus();

  document.body.addEventListener('htmx:afterSwap', (event) => {
    initUserActionsMenus(event.target as ParentNode);
  });

  document.body.addEventListener('htmx:oobAfterSwap', (event) => {
    initUserActionsMenus(event.target as ParentNode);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initialize, { once: true });
} else {
  initialize();
}
